import { apiClient } from './api/client';

export interface SettingsData {
  [key: string]: any;
}

export const settingsService = {
  /**
   * Récupère tous les paramètres
   */
  async getAll(): Promise<SettingsData> {
    const response = await apiClient.get('/settings');
    return response as SettingsData;
  },

  /**
   * Récupère les paramètres d'une section spécifique
   */
  async getBySection(sectionId: string): Promise<SettingsData> {
    const response = await apiClient.get(`/settings/${sectionId}`);
    return response as SettingsData;
  },

  /**
   * Récupère la clé publique Stripe (route publique)
   */
  async getStripePublishableKey(): Promise<string> {
    const response = await apiClient.get<{ publishable_key: string }>('/settings/public/stripe-publishable-key');
    return (response?.publishable_key || '').trim();
  },

  /**
   * Récupère les méthodes de paiement activées (route publique)
   */
  async getPaymentMethods(): Promise<{
    enable_cash_on_delivery: boolean;
    enable_bank_transfer: boolean;
    enable_credit_card: boolean;
    enable_paypal: boolean;
  }> {
    const response = await apiClient.get('/settings/public/payment-methods');
    return response as any;
  },

  /**
   * Sauvegarde les paramètres d'une section
   */
  async saveSection(sectionId: string, data: SettingsData): Promise<void> {
    await apiClient.put(`/settings/${sectionId}`, data);
  },

  /**
   * Sauvegarde tous les paramètres
   */
  async saveAll(data: SettingsData): Promise<void> {
    await apiClient.put('/settings', data);
  },

  /**
   * Réinitialise une section aux valeurs par défaut
   */
  async resetSection(sectionId: string): Promise<void> {
    await apiClient.delete(`/settings/${sectionId}`);
  },

  /**
   * Actions spéciales (logout all, disable account, etc.)
   */
  async executeAction(action: string, params?: any): Promise<any> {
    const response = await apiClient.post('/settings/actions', { action, params });
    return response;
  },
};
